"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../styles/styles"));
const screenConstants_1 = require("../../constants/screenConstants");
const typesConstants_1 = require("../../constants/typesConstants");
const eventConstants_1 = require("../../constants/eventConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const qualityAssuranceConstants_1 = require("./qualityAssuranceConstants");
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const qualityAssuranceSlice_1 = require("./qualityAssuranceSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const colors_1 = __importDefault(require("../../styles/colors"));
const constants_1 = require("../../constants/constants");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const navigationButton_1 = __importDefault(require("../../components/button/navigationButton"));
const callDetailRecordTable_1 = __importDefault(require("../../components/auditComponent/callDetailRecordTable"));
const audioPlayer_1 = __importDefault(require("../../components/audioComponent/audioPlayer"));
const filterCallRecord_1 = __importDefault(require("../../components/filterCallRecord/filterCallRecord"));
const auditSummary_1 = __importDefault(require("../../components/auditComponent/auditSummary"));
const AuditedCallDetailRecord = () => {
    const { loadingStatus, officer, callRecords, selectedCallRecordAudit, selectedCallRecordIndex } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
        callRecords: state.qualityAssurance.callRecords,
        loadingStatus: state.qualityAssurance.loadingStatus,
        selectedCallRecordAudit: state.qualityAssurance.selectedCallRecordAudit,
        selectedCallRecordIndex: state.qualityAssurance.selectedCallRecordIndex,
    }));
    const route = native_1.useRoute();
    const callRecordId = route.params && route.params.call_record_id;
    const [displayAudit, setDisplayAudit] = react_1.useState(false);
    const [queryParams, setQueryParams] = react_1.useState({
        review_status: qualityAssuranceConstants_1.REVIEWED,
        ...(callRecordId && { id: callRecordId }),
        ...(!officer.is_manager && { officer_id: officer.id }),
    });
    const [callRecord, setCallRecord] = react_1.useState(null);
    const isDesktop = useWebDesktopDesign_1.default(constants_1.DESKTOP_BREAKPOINT_2);
    const dispatch = useAppDispatch_1.default();
    const navigator = native_1.useNavigation();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const displayAudioPlayer = !!(callRecords.length > 0 &&
        typeof selectedCallRecordIndex === 'number' &&
        callRecords[selectedCallRecordIndex] &&
        callRecords[selectedCallRecordIndex].record);
    // Get audited callrecords
    react_1.useEffect(() => {
        dispatch(qualityAssuranceSlice_1.getCallDetailRecords(queryParams));
    }, []);
    const onRowPress = ({ record }) => {
        setCallRecord(record);
        const callRecordIndex = callRecords.indexOf(record);
        if (callRecordIndex !== selectedCallRecordIndex) {
            dispatch(qualityAssuranceSlice_1.setSelectedCallRecordIndex(callRecordIndex));
        }
        dispatch(qualityAssuranceSlice_1.getCallDetailRecordAudit({ call_detail_record: record.id }));
        setDisplayAudit(true);
    };
    const onPageChange = (page) => {
        const updateParams = { ...queryParams, page };
        setQueryParams(updateParams);
        dispatch(qualityAssuranceSlice_1.resetCallRecordState());
        dispatch(qualityAssuranceSlice_1.getCallDetailRecords(updateParams));
    };
    let content = react_1.default.createElement(react_1.default.Fragment, null);
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    else if (loadingStatus === typesConstants_1.SUCCEEDED_STATUS) {
        content = (react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexDirectionRow },
            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexFour },
                react_1.default.createElement(callDetailRecordTable_1.default, { onPageChange: onPageChange, onRowPress: onRowPress })),
            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexOne },
                react_1.default.createElement(filterCallRecord_1.default, { setQueryParams: setQueryParams, queryParams: queryParams }))));
    }
    else {
        content = react_1.default.createElement(messageComponent_1.default, { message: "An error occurred.", color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    }
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Audited Calls" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null, displayAudit && !!selectedCallRecordAudit && !!callRecord ? (react_1.default.createElement(navigationButton_1.default, { onPress: () => setDisplayAudit(false), title: "Audited Calls", event: eventConstants_1.NAVIGATE_AUDITED_CDR_BUTTON })) : (react_1.default.createElement(navigationButton_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), title: "Dashboard", event: eventConstants_1.NAVIGATE_HOME_BUTTON }))))),
            react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexDirectionColumn }, displayAudit && !!selectedCallRecordAudit && !!callRecord ? (react_1.default.createElement(react_1.default.Fragment, null,
                displayAudioPlayer && (react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.boxStyles,
                            styles_1.default.flexOne,
                            styles_1.default.blueBackground,
                        ] },
                        react_1.default.createElement(audioPlayer_1.default, null)))),
                react_1.default.createElement(auditSummary_1.default, { callDetailRecordAudit: selectedCallRecordAudit, callRecord: callRecord }))) : (react_1.default.createElement(react_native_1.View, { style: isDesktop && styles_1.default.flexFour }, content))))));
};
exports.default = AuditedCallDetailRecord;
